import React, { PureComponent } from 'react';
import PageBaseView from './PageBaseView/PageBaseView';
import actions from '../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DEFAULT_ACTIVE_BRANCH_ID } from '../../../constants/constants';

class PageBase extends PureComponent {
  constructor(props) {
    super(props);

    this.getBranches = this.getBranches.bind(this);
    this.onChangeBranch = this.onChangeBranch.bind(this);
  }

  getBranches() {
    const branches = this.props.includeInactiveBranches
      ? this.props.appStore.branches
      : this.props.appStore.branches.filter((branch) => branch.hasActiveGM);

    return [
      {
        branchId: DEFAULT_ACTIVE_BRANCH_ID,
        branchDesc: 'All Branches',
        default: true
      },
      ...branches
    ];
  }

  onChangeBranch(event) {
    this.props.actions.setActiveBranch(event.target.value);
  }

  render() {
    return (
      <PageBaseView
        selectedBranchId={this.props.appStore.activeBranchId}
        branches={this.getBranches()}
        disableBranchSelect={this.props.appStore.branches.length <= 1}
        onChangeBranch={this.onChangeBranch}
        {...this.props}
      />
    );
  }
}

PageBase.propTypes = {
  navigation: PageBaseView.propTypes.navigation,
  loading: PageBaseView.propTypes.loading,
  includeInactiveBranches: PageBaseView.propTypes.includeInactiveBranches
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PageBase);
